import { Outlet } from 'react-router';
import { Card, CardHeader, CardBody } from '@heroui/react';

export const Layout = () => {
  return (
    <Card className="w-full max-w-sm items-center bg-white/0">
      <CardHeader className="bg-white/30 backdrop-blur-md justify-center">
        <div className="flex flex-col items-center">
          <img
            src="//cdn.lifebeacon.com/img/logo_primary.png"
            alt="LiveFree Logo"
            width="200"
          ></img>
        </div>
      </CardHeader>
      <CardBody className="bg-white/20 backdrop-blur-md p-4">
        <Outlet />
      </CardBody>
    </Card>
  );
};
